








import '@/styles/root.scss'
import Vue from 'vue'
import Component from 'vue-class-component'
import BrowserNotSupported from './views/common/BrowserNotSupported.vue'
import { Debounce } from 'vue-debounce-decorator'
import Api from '@/api'
import { UserModule } from '@/store/modules/user.module'
import { getModule } from 'vuex-module-decorators'
import { ChainModule } from '@/store/modules/chain.module'
import ScrollView from '@/components/ScrollView.vue'
import NotificationBar from '@/components/NotificationBar.vue'
import { NoCache } from './decorators/NoCache'

const { detect } = require('detect-browser')
const browser = detect()

@Component({
  components: {
    ScrollView,
    NotificationBar,
    BrowserNotSupported
  }
})
export default class Root extends Vue {
  lastActivity: Date = new Date()
  isBrowserSupported: boolean = true
  userModule: UserModule = getModule(UserModule, this.$store)
  chainModule: ChainModule = getModule(ChainModule, this.$store)
  isScrollDisabled: boolean = false

  goLoginIfNeed () {
    const userData = (this.user || { data: null }).data
    if (
      (
        window.location.pathname.includes('/admin/') ||
        window.location.pathname.includes('/management/') ||
        window.location.pathname.includes('/portal/')
      ) && (!this.user || this.user.isExpired())
    ) {
      Api.logout(false)
      this.$router.push({ name: 'login', query: { nextUrl: window.location.pathname } })
    } else {
      this.userModule.setUser(userData)
    }
  }

  async mounted () {
    const userData = (this.user || { data: null }).data
    await this.chainModule.getChainById((userData || { chain: '' }).chain as string | number)

    this.goLoginIfNeed()
    setInterval(this.checkActivity.bind(this), 10 * 1000)

    if (browser && browser.name === 'ie') {
      this.isBrowserSupported = false
    }
    this.$eventBus.$on('Root:disableScroll', () => {
      this.isScrollDisabled = true
    })
    this.$eventBus.$on('Root:enableScroll', () => {
      this.isScrollDisabled = false
    })
    this.$watch('$route', () => {
     this.$eventBus.$emit('loading:disable')
    })

    await Api.utils.getAppVersion()
  }

  @NoCache
  get user () {
    return Api.getUser()
  }

  beforeDestroy () {
  }

  checkActivity () {
    const userData = (this.user || { data: null }).data
    if (this.user) {
      if (this.user.data.chain || Date.now() - this.lastActivity.getTime() < this.user.expireDefault) {
        Api.updateTokenIfNeed()
      }
    } else {
      this.userModule.setUser(userData)
    }
    this.goLoginIfNeed()
  }

  @Debounce(10 * 1000)
  handleActivity () {
    if (this.user) {
      this.userModule.setUser((this.user || { data: null }).data)
      this.lastActivity = new Date()
    }
  }

  emitClick () {
    this.$eventBus.$emit('body:click')
  }
}
